import { joinParts } from '../utils'

export const typeticketcollection = {
  data: (id: number) => joinParts('typeticketcollections', String(id)),
  bulk: (ids: string[]) => `/typeticketcollections?ids=${ids.join(',')}`,
}
